// Colunas do grid.
export const Columns = [
	{
		headerName: 'reason',
		field: 'name',
		filter: true,
		width: 500
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans'
	}
]